import React, { Component } from "react";
import { ButtonToolbar, OverlayTrigger, Tooltip } from "react-bootstrap";
// import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
// const bgImage = toAbsoluteUrl("/media/error/bg5.jpg");
class BentukKetercapaianMsStudi extends Component {
//     state = {
//         ref_data : [],
//         display: false,
//       }
//     componentDidMount(){
//     let data_ref = []
//     let no = 0;
//     for (var key in this.props.masa_studi) {
//       if (this.props.masa_studi.hasOwnProperty(key)) {
//         data_ref[no] = {
//           "name" : key,
//           "indicator" : this.props.masa_studi[key],
//           "value": 0,
//         }
//         no++;
//       }
//     }
//     if(this.state.display === false){
//       this.setState({
//         display: true,
//         ref_data: data_ref,
//       })
//     }
//   }
    render(){
        let ref = this.props.masa_studi;
            let data_ref = []
            let no = 0;
            for (var key in ref) {
              if (ref.hasOwnProperty(key)) {
                data_ref[no] = {
                  "name" : key,
                  "indicator" : ref[key],
                  "value": 0,
                }
                no++;
              }
            }
        console.log("DATA =",data_ref )
        let view = [];
        
        if(ref !== undefined){
            view = <>
            {
              data_ref.map((list,i)=>
              (list.indicator.minimum_value !== undefined) ? <tr>
                  <td className="font-size-sm"><b>{list.name}</b></td>
                  <td style={{textAlign:'center'}}>
                    <span className="text-dark-75  d-block font-size-sm">
                      {list.indicator.minimum_value}
                    </span>
                  </td>
                  <td style={{textAlign:'center'}}>
                    {list.indicator.target !== undefined ? list.indicator.target : list.indicator.minimum_value }
                  </td>
                  {/* <td style={{textAlign:'center'}}>-
                      <span className="font-size-sm ">
                          2,3&nbsp;
                          <span className="fa fa-caret-up text-success fa-lg"></span>
                      </span>
                  </td> */}
                </tr>
                : ""
              )
            }
            </>;
          }
        return(
            <>
            {/* begin::Body */}
            <div className="">
                {/* begin::Table */}
                <div className="table-responsive" bordered={false}>
                <table
                    className="table  table-vertical-center"
                    id="kt_advance_table_widget_1"
                >
                    
                    <thead className="text-white" style={{backgroundColor:'#3047ad'}}>
                                <tr>
                                    <th style={{fontSize:'12px', textTransform: 'uppercase', verticalAlign: 'middle'}}>MASA STUDI MAKSIMAL PADA PROGRAM PENDIDIKAN</th>
                                    <th style={{fontSize:'12px', textTransform: 'uppercase', verticalAlign: 'middle', textAlign:'center'}}>SNDIKTI</th>
                                    <th style={{minWidth:'130px',textAlign:'center', fontSize:'12px', textTransform: 'uppercase', verticalAlign: 'middle'}}>
                                        TARGET INTERNAL YANG DITETAPKAN PERGURUAN TINGGI
                                        <OverlayTrigger
                                        key="bottom"
                                        placement="bottom"
                                        overlay={
                                            <Tooltip id={`tooltip-bottom`}>
                                                <div style={{textAlign:'left'}}>
                                                    Target yang telah ditetapkan pada halaman pengaturan tentang kebijakan SPMI
                                                </div>
                                            </Tooltip>
                                        }
                                        >
                                        <span>
                                            &nbsp;&nbsp;
                                            <span style={{fontSize:'15px'}} className="text-white fa fa-info-circle"></span>
                                        </span>
                                        </OverlayTrigger>
                                    </th>
                                    {/* <th style={{textAlign:'center', fontSize:'12px', textTransform: 'uppercase', verticalAlign: 'middle'}}>
                                    data sekarang
                                        <OverlayTrigger
                                            key="internal"
                                            placement="internal"
                                            overlay={
                                                <Tooltip id={`tooltip-internal`}>
                                                    <div style={{textAlign:'left'}}>
                                                        <div style={{textAlign:'left'}}>
                                                            <strong>Data yang tercapai pada setiap Program Studi ditandai warna icon :</strong><br/>
                                                            <span className="text-danger flaticon-add-label-button"></span>
                                                            &nbsp;Merah Tidak Melampaui
                                                            <br/>
                                                            <span className="text-success flaticon-add-label-button"></span>
                                                            &nbsp;Hijau Telah Melampaui
                                                        </div>
                                                    </div>
                                                </Tooltip>
                                            }
                                            >
                                            <>&nbsp;&nbsp;<span style={{fontSize:'15px'}} className="text-white fa fa-info-circle"></span></>
                                            </OverlayTrigger>
                                    </th> */}
                                </tr>
                            </thead>
                    <tbody>
                        {view}
                    </tbody>
                </table>
                </div>
                {/* end::Table */}
            </div>
            </>
        )
    }
}
export default BentukKetercapaianMsStudi;